function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { keyMap } from '@finect/front-utils/keyMap';
import { isBrowser } from '@finect/front-utils/isBrowser';
import { ModalOverlay, ModalBox, ModalContent, ContentWrapper } from './partials';
import { CloseAction } from './components';
export var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);
  var _super = _createSuper(Modal);
  function Modal() {
    var _this;
    _classCallCheck(this, Modal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "target", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "overlayNode", React.createRef());
    _defineProperty(_assertThisInitialized(_this), "scrollPosition", 0);
    _defineProperty(_assertThisInitialized(_this), "enableScroll", function () {
      var $body = document.querySelector('body');
      $body.style.removeProperty('overflow');
      $body.style.removeProperty('position');
      $body.style.removeProperty('top');
      $body.style.removeProperty('width');
      window.scrollTo(0, _this.scrollPosition);
    });
    _defineProperty(_assertThisInitialized(_this), "disableScroll", function () {
      var $body = document.querySelector('body');
      _this.scrollPosition = window.pageYOffset;
      $body.style.overflow = 'hidden';
      $body.style.position = 'fixed';
      $body.style.top = "-".concat(_this.scrollPosition, "px");
      $body.style.width = '100%';
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (event) {
      if (_this.props.disableClose || _this.props.disableCloseOnKey) return;
      if (event.keyCode === keyMap.ESCAPE) _this.handleClose();
    });
    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function () {});
    _defineProperty(_assertThisInitialized(_this), "attachEvents", function () {
      document.addEventListener('mousedown', _this.handleOutsideClick, false);
      document.addEventListener('keydown', _this.handleKeydown, false);
      if (_this.props.scrollLock) {
        _this.disableScroll();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "detachEvents", function (snapshot) {
      document.removeEventListener('mousedown', _this.handleOutsideClick, false);
      document.removeEventListener('keydown', _this.handleKeydown, false);
      if (_this.props.scrollLock) _this.enableScroll();
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      if (typeof _this.props.onClose !== 'undefined') {
        _this.props.onClose();
      }
    });
    return _this;
  }
  _createClass(Modal, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      return prevProps.show !== this.props.show ? this.target : null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!isBrowser()) return;
      if (this.props.show) this.attachEvents();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.show) this.detachEvents(this.target);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.show === this.props.show) return;
      if (!isBrowser()) return;
      this.props.show && this.attachEvents();
      !this.props.show && this.detachEvents(snapshot);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$withDOM = _this$props.withDOM,
        withDOM = _this$props$withDOM === void 0 ? false : _this$props$withDOM,
        show = _this$props.show;
      if (!this.props.show && !withDOM) return null;
      var display = withDOM && !show ? 'none' : 'block';
      var _this$props2 = this.props,
        children = _this$props2.children,
        fullScreen = _this$props2.fullScreen,
        heightSize = _this$props2.heightSize,
        minHeight = _this$props2.minHeight,
        disableClose = _this$props2.disableClose,
        widthSize = _this$props2.widthSize,
        closeActionVisible = _this$props2.closeActionVisible,
        zIndex = _this$props2.zIndex,
        withPaddingTop = _this$props2.withPaddingTop;
      var variant = fullScreen ? 'fullScreen' : this.props.variant || null;
      var withIframe = children && children.type && children.type === 'iframe';
      var withCloseAction = !disableClose && closeActionVisible;
      return React.createElement(ModalOverlay, {
        $display: display,
        zIndex: zIndex || 10000000,
        ref: this.overlayNode
      }, React.createElement(ModalBox, null, React.createElement(ModalContent, {
        variant: variant,
        widthSize: widthSize,
        withPaddingTop: withPaddingTop
      }, withCloseAction ? React.createElement(CloseAction, {
        onAction: this.handleClose,
        withPaddingTop: withPaddingTop
      }) : null, React.createElement(ContentWrapper, {
        heightSize: heightSize,
        withIframe: withIframe,
        minHeight: minHeight,
        ref: this.target
      }, children))));
    }
  }]);
  return Modal;
}(React.Component);
_defineProperty(Modal, "defaultProps", {
  zIndex: 10000000,
  fullScreen: false,
  show: true,
  minHeight: null,
  heightSize: 'auto',
  disableCloseOnKey: false,
  disableClose: false,
  widthSize: 'large',
  scrollLock: true,
  withPaddingTop: false,
  closeActionVisible: true
});